export default {
  ADD_MEMBERS_IN_SEGMENT(state, payload) {
    state[payload.key] = payload.value;
  },
  SEGMENT_DATA(state, payload) {
    state.segments = payload;
  },
};
